/* eslint-disable import/max-dependencies */
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid, LoadingOverlay } from 'src/components/DataGrid';
import Delete from '@mui/icons-material/DeleteOutline';
import { GridColDef } from '@mui/x-data-grid';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import { useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAddBCN } from '../../hooks/multi-bcn';

import Typography from '@mui/material/Typography';
import { useAccount } from '@azure/msal-react';

export type BCN = {
  Id: number;
  bcnNumber: string;
};
export function commaSeparatedValue(rows: BCN[], inputValue: string) {
  const value = inputValue
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item);
  const newItems: BCN[] = value.map((name, index) => ({
    Id: rows.length + index,
    bcnNumber: name,
  }));
  return newItems;
}
export default function AddBcnPage(
  props: Readonly<{
    BcnCameOnDeal: boolean;
    bcn_linking_level: string;
    customerSetId: string;
    dealId: string;
    handleClose: () => void;
  }>
) {
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const importreferenceid = searchParams.get('importreferenceid');
  const [inputValue, setInputValue] = useState<string>('');
  const [bcn, setBcn] = useState<string>('');

  const [rows, setRows] = useState<BCN[]>([]);
  const handelDeleteBCN = (id: number) => {
    setRows((prevRows) => prevRows.filter((row) => row.Id !== id));
  };
  const columnNames = [
    {
      align: 'left',
      field: 'bcnNumber',
      headerName: translate('VendorProgram.AddBcnGridHeader'),
    },
    {
      align: 'right',
      field: '',
      headerName: '',
    },
  ];

  const columns: GridColDef[] = columnNames.map((col) => ({
    align: col.align as 'left' | 'right' | 'center' | undefined,
    cellClassName: 'cellvender',
    field: col.field,
    flex: 1,
    headerName: col.headerName,
    renderCell: (item) => {
      if (col.headerName === '') {
        return (
          <IconButton
            data-testid="gds-bcn-list-delterow"
            onClick={() => handelDeleteBCN(item.row.Id)}
          >
            <Delete />
          </IconButton>
        );
      } else {
        return item.value;
      }
    },
    sortable: false,
  }));

  const [reprocessMsg, setReprocessMsg] = useState<string | undefined>();
  const addBCNList = useAddBCN();
  const userName = useAccount()?.username ?? '';
  const handleAddBCNlist = () => {
    addBCNList
      .mutateAsync({
        BCN: String(inputValue),
        customerset_Id: props.customerSetId,
        deal_Id: props.dealId,
        editor: userName,
        importreferenceid: importreferenceid ?? '',
        source: props.bcn_linking_level,
      })
      .then((response) => setReprocessMsg('Success'))
      .catch((error) => setReprocessMsg(error));
    setInputValue('');
  };

  const handleAddBcns = () => {
    const newItems = commaSeparatedValue(rows, inputValue);
    setRows((prevItem) => [...prevItem, ...newItems]);
    setBcn('');
  };

  const validateBcn = (string: string) => {
    if (!string || string.length === 0) {
      return true;
    }
    const regex: any = /^[A-Z0-9a-z]{8}$/;
    const result = string.split(',').map((i) => i.trim());
    for (const i of result) {
      if (
        !regex.test(i)
        // (props.branchCodes && !props.branchCodes.includes(i.slice(0, 2)))
      ) {
        return false;
      }
    }
    return true;
  };

  const handleBcnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBcn(event.target.value);
    if (validateBcn(event.target.value)) {
      setInputValue(event.target.value);
    } else {
      setInputValue('');
    }
  };

  return (
    <Dialog
      data-testid="Add-bcnList-dialog"
      maxWidth="md"
      onClose={props.handleClose}
      open={true}
      sx={{ height: '644px' }}
    >
      <DialogTitle data-testid="vp-bcnList-dialog-title">
        <Stack>{translate('VendorProgram.BcnListTitle')}</Stack>
        <IconButton
          data-testid="add-bcn-close-btn"
          onClick={props.handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {reprocessMsg === 'Success' ? (
        <Box
          alignItems={'center'}
          display={'flex'}
          flexDirection={'column'}
          height={'50vh'}
          justifyContent={'center'}
        >
          <CheckCircleIcon sx={{ color: '#1976d2', fontSize: 64 }} />
          <Typography variant="h1">
            {translate('VendorProgram.AddBcnMessage')}
          </Typography>
        </Box>
      ) : (
        <Stack>
          <DialogContent>
            <Stack
              direction={'row'}
              flex={1}
              justifyContent={'center'}
              p={2}
              spacing={2}
            >
              <TextField
                error={!validateBcn(bcn)}
                helperText={translate(
                  !validateBcn(bcn)
                    ? 'VendorProgram.EnterBcnValidationMessage'
                    : 'VendorProgram.EnterBcnHelperText'
                )}
                onChange={handleBcnChange}
                placeholder={translate('VendorProgram.EnterBcnPlaceholder')}
                sx={{ marginRight: '10px', width: '100%' }}
                type="text"
                value={bcn}
              ></TextField>
              <Button
                data-testid="gds-vp-Bcnadd-add-btn"
                onClick={handleAddBcns}
                startIcon={<AddIcon />}
                sx={{ paddingLeft: '21px', paddingRight: '29px' }}
                variant="newContained"
              >
                {' '}
                {translate('VendorProgram.AddBCN')}
              </Button>
            </Stack>
            <Box>
              <DataGrid
                autoHeight
                columnBuffer={columns.length}
                columns={columns}
                components={{
                  LoadingOverlay: LoadingOverlay,
                }}
                data-testid="gds-vp-AddBcn-list-dataGrid"
                disableColumnFilter
                disableColumnMenu
                disableColumnSelector
                disableSelectionOnClick
                getRowHeight={() => 'auto'}
                getRowId={(id) => id.Id}
                hideFooterPagination={true}
                rows={rows as any}
                sx={{
                  '.MuiDataGrid-columnHeader--moving': {
                    backgroundColor: 'transparent',
                  },
                  '.MuiDataGrid-columnHeaderTitle': {
                    whiteSpace: 'normal',
                  },
                  '.MuiDataGrid-row': {
                    minHeight: '52px !important',
                  },
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              data-testid="gds-vp-addvpn-add-btnpoup-btn"
              disabled={rows.length === 0}
              onClick={handleAddBCNlist}
              startIcon={<AddIcon />}
              variant="newContained"
            >
              {translate('VendorProgram.AddBcnListbtn')}
            </Button>
          </DialogActions>
        </Stack>
      )}
    </Dialog>
  );
}
